// Lazily loads exceljs on demand so the library is excluded from the main
// bundle and fetched only on the first export click (cached thereafter).
// exceljs ships as CommonJS — its namespace `default` is the real module.
export const loadExcelJS = () =>
  import("exceljs").then((mod) => mod.default ?? mod);
